// /src/store/thirdPartyStreaming/reducer.ts

import {
  FETCH_STREAMING_SERVICES_REQUEST,
  FETCH_STREAMING_SERVICES_SUCCESS,
  FETCH_STREAMING_SERVICES_FAILURE,
  FETCH_STREAMING_CHANNELS_REQUEST,
  FETCH_STREAMING_CHANNELS_SUCCESS,
  FETCH_STREAMING_CHANNELS_FAILURE,
  ThirdPartyStreamingState,
  initialState,
  ThirdPartyStreamingActionTypes,
} from './types';

const thirdPartyStreamingReducer = (state = initialState, action: ThirdPartyStreamingActionTypes): ThirdPartyStreamingState => {
  switch (action.type) {
    case FETCH_STREAMING_SERVICES_REQUEST:
    case FETCH_STREAMING_CHANNELS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_STREAMING_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.payload,
        lastFetchTimestamp: new Date().getTime(),
      };

    case FETCH_STREAMING_CHANNELS_SUCCESS:
      return {
        ...state,
        loading: false,
        channels: action.payload,
        lastFetchTimestamp: new Date().getTime(),
      };

    case FETCH_STREAMING_SERVICES_FAILURE:
    case FETCH_STREAMING_CHANNELS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default thirdPartyStreamingReducer;
